import { render, staticRenderFns } from "./adddoctrans.vue?vue&type=template&id=1a1af6be&"
import script from "./adddoctrans.vue?vue&type=script&lang=js&"
export * from "./adddoctrans.vue?vue&type=script&lang=js&"
import style0 from "./adddoctrans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports